import React from "react";
import { footer, brand } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-[#16204a] py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4">
        <h2 className="max-w-3xl text-3xl md:text-5xl font-extrabold leading-tight text-white">
          {footer.headingA}
          <span className="text-[#f5c842]">{footer.headingAccent}</span>.
        </h2>

        <div className="my-10 h-px w-full bg-white/15" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <img
              src={brand.logo}
              alt="Grupo IFT"
              className="h-20 w-auto object-contain brightness-0 invert"
            />
            <p className="mt-4 text-xs font-bold uppercase tracking-[0.2em] text-[#f5c842]">
              {brand.tagline}
            </p>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.16em] text-white/50">
              {footer.emailLabel}
            </p>
            <a
              href={`mailto:${brand.email}`}
              className="mt-2 inline-block text-lg text-white transition-colors hover:text-[#f5c842]"
            >
              {brand.email}
            </a>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.16em] text-white/50">
              {footer.locationLabel}
            </p>
            <p className="mt-2 text-lg text-white">{brand.location}</p>
          </div>
        </div>

        <div className="my-10 h-px w-full bg-white/15" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-white/50">{footer.copyright}</p>
          <a
            href={footer.reservedUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-white/50 transition-colors hover:text-[#f5c842]"
          >
            {footer.reserved}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
